import {type JSONData} from "../../base_classes/dto.d";
import {AdministrationDto} from "./dto.gen";
import {type IAdministration} from "./entity.d";
import AdministrationParsers from "./parsers";
import AdministrationValidators from "./custom_validators";

export class Administration extends AdministrationDto implements IAdministration {
  constructor(
    pathVars?:
      | string
      | string[]
      | {
      id?: string;
    },
    data?: JSONData
  ) {
    super(data, AdministrationParsers, AdministrationValidators);

    if (data !== undefined) {
      // Set data
      this.set(data);
    }

    this.buildPathObject(pathVars);
  }

  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  public skus: string[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  public async get(
    pathVars?:
      | string
      | string[]
      | {
      id?: string;
    }
      | undefined
  ): Promise<Administration> {
    return (await super.get(pathVars)) as Administration;
  }

  /// ///////////////////////////////////////
  /// /////////// STATIC METHODS ////////////
  /// ///////////////////////////////////////

  static override FromJSON(data?: JSONData): Administration {
    return new Administration(undefined, data);
  }

  static override FromJSONArray(data: JSONData[]): Administration[] {
    return data.map((item) => Administration.FromJSON(item));
  }

  static FromDto(dto: AdministrationDto): Administration {
    return new Administration(undefined, dto.toJSON());
  }

  generateId() {
    // use the slug of the name as the id
    if (this.name) {
      this.id = this.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    } else {
      this.id = 'new';
    }
  }
}
